import { Routes, Route, Navigate } from "react-router-dom";
import InterceptorProfile from "../components/profile/interceptorProfile";
import CambioClave from "../pages/confirmacion/cambioClave";
import ConfirmacionCorreo from "../pages/confirmacion/confirmacionCorreo";
import ConfirmacionPago from "../pages/confirmacion/confirmacionPago";
import Cobertura from "../pages/consulta/cobertura";
import HistorialConsumo from "../pages/consulta/historialConsumo";
import Prestador from "../pages/consulta/prestador";
import Home from "../pages/home/Home";
import Login from "../pages/login/Login";
import OnboardingPage from "../pages/onboarding/onboarding";
import Pagos from "../pages/pagos/pagos";
import Profile from "../pages/profile/profile";
import Solicitudes from "../pages/solicitudes/solicitudes";
import Citas from "../pages/turnos/citas";
import SolicitudAfiliacion from "../pages/formulario/solicitudAfiliacion";
import InterceptorAnonimo from "../components/interceptors/interceptorAnonimo";
import PagoMovil from "../pages/pagos/movil/pagoMovil";
import ClubBeneficiarios from "../pages/club/clubBeneficiarios";
import CambioCorreo from "../pages/cambioCorreo/cambioCorreo";
import ReversoCorreo from "../pages/cambioCorreo/reversoCorreo";
import ConfirmarAfiliado from "../pages/confirmacion/confirmarAfiliado";
import Carne from "../pages/carne/carne";
import ConfirmacionBilletera from "../pages/confirmacion/confirmacionBilletera";
import InterceptorRequiereLogin from "../components/interceptors/interceptorRequiereLogin";
import InterceptorDispositivoSeguro from "../components/interceptors/interceptorDispositivoSeguro";
import Medicamentos from "../pages/consulta/medicamento";

const MainRoute = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <InterceptorDispositivoSeguro>
            <Home />
          </InterceptorDispositivoSeguro>
        }
      />
      <Route
        path="onboarding"
        element={
          <InterceptorRequiereLogin path={"/onboarding"}>
            <OnboardingPage />
          </InterceptorRequiereLogin>
        }
      />
      <Route
        path="profile"
        element={
          <InterceptorRequiereLogin path={"/profile"}>
            <InterceptorProfile>
              <InterceptorDispositivoSeguro>
                <Profile />
              </InterceptorDispositivoSeguro>
            </InterceptorProfile>
          </InterceptorRequiereLogin>
        }
      />
      <Route
        path="solicitudes"
        element={
          <InterceptorRequiereLogin path={"/solicitudes"}>
            <Solicitudes />
          </InterceptorRequiereLogin>
        }
      />
      <Route
        path="club"
        element={
          <InterceptorRequiereLogin path={"/club"}>
            <ClubBeneficiarios />
          </InterceptorRequiereLogin>
        }
      />
      <Route path="consulta">
        <Route
          path="medicamentos"
          element={
            <InterceptorRequiereLogin path={"/consulta/medicamentos"}>
              <Medicamentos />
            </InterceptorRequiereLogin>
          }
        />
        <Route
          path="prestadores"
          element={
            <InterceptorRequiereLogin path={"/consulta/prestadores"}>
              <InterceptorAnonimo>
                <Prestador />
              </InterceptorAnonimo>
            </InterceptorRequiereLogin>
          }
        />
        <Route
          path="consumos"
          element={
            <InterceptorRequiereLogin path={"/consulta/consumos"}>
              <HistorialConsumo />
            </InterceptorRequiereLogin>
          }
        />
        <Route
          path="cobertura"
          element={
            <InterceptorRequiereLogin path={"/consulta/cobertura"}>
              <InterceptorAnonimo>
                <Cobertura />
              </InterceptorAnonimo>
            </InterceptorRequiereLogin>
          }
        />
      </Route>
      <Route path="login" element={<Login />} />
      <Route path="solicitud">
        <Route
          path="confirmacioncorreo/:codigoAfiliado"
          element={<ConfirmacionCorreo />}
        />
        <Route path="cambioClave/:Token" element={<CambioClave />} />
        <Route
          path="confirmacionPago/:ResponseCode"
          element={<ConfirmacionPago />}
        />
        <Route path="CambioCorreo/:Token" element={<CambioCorreo />} />
        <Route path="ReversoCorreo/:Token" element={<ReversoCorreo />} />
        <Route
          path="confirmarAfiliado/:Token"
          element={<ConfirmarAfiliado />}
        />
      </Route>
      <Route path="pagos">
        <Route
          path=""
          element={
            <InterceptorRequiereLogin path={"/pagos"}>
              <Pagos />
            </InterceptorRequiereLogin>
          }
        />
        <Route path="movil/:Token" element={<PagoMovil />} />
      </Route>
      <Route
        path="confirmacionBilletera/:token"
        element={<ConfirmacionBilletera />}
      />
      <Route
        path="citas"
        element={
          <InterceptorRequiereLogin path={"/citas"}>
            <Citas />
          </InterceptorRequiereLogin>
        }
      />
      <Route path="formulario">
        <Route path="solicitudAfiliacion" element={<SolicitudAfiliacion />} />
      </Route>
      <Route
        path="carne"
        element={
          <InterceptorRequiereLogin path={"/carne"}>
            <Carne />
          </InterceptorRequiereLogin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MainRoute();